import { useInfiniteQuery } from 'react-query';
import axios from 'axios';
import { useUserStore } from '~providers/userStore/zustand';

import { BASE_API_URL } from '@env';
import { GetEventsParams } from '~types/events';

let NUMBER_OF_EVENTS_PER_PAGE = 20;

export const useAllEvents = ({
  tab,
  order_by,
  order_dir,
  distance_km,
  event_age_group,
  enabled = false,
  q,
  filter_my_event_type,
  filter_type,
  user_id,
  timeframe,
  isMap = false,
  event_service_type
}: Omit<GetEventsParams, 'offset' | 'limit'> & { enabled?: boolean }) => {
  const fetchEvents = async ({ pageParam = 0 }) => {
    const token = useUserStore.getState().token;
    console.log(token, 'token');
    console.log(isMap, 'isMapisMapisMapisMap');


    NUMBER_OF_EVENTS_PER_PAGE = isMap ? 10000 : 20;
    const offset = pageParam * NUMBER_OF_EVENTS_PER_PAGE;
    const limit = NUMBER_OF_EVENTS_PER_PAGE;
    console.log(offset, limit, 'offset, limit');


    const params: GetEventsParams = {
      limit,
      offset,
      tab,
      order_by,
      order_dir,
      distance_km,
      event_age_group,
      q,
      filter_my_event_type,
      filter_type,
      user_id,
      timeframe,
      event_service_type
    };

    console.log(params, 'paramsparamsparams');


    const config = {
      headers: { Authorization: token, Accept: 'application/json' },
    };

    try {
    const response = await axios.get(BASE_API_URL + 'events/', { params, ...config });
    console.log(response, 'responseresponse');

    return response.data;
    } catch (error) {
    console.log(error, 'responseresponse');
    }
  };

  return useInfiniteQuery('eventsAll', fetchEvents, {
    getNextPageParam: (lastPage, pages) => {
      const items = lastPage?.items || lastPage?.data || [];
      const nextPage = items.length === NUMBER_OF_EVENTS_PER_PAGE ? pages.length : undefined;
      return nextPage;
    },
    enabled,
    cacheTime: 0,
  });
};

/* Not working optimised variant
import {GetEventsParams} from '~types/events';
import {useOptimizedEvents} from '~hooks/performance/useOptimizedEvents';

// Wrapper for backward compatibility - now uses optimized version
export const useAllEvents = ({
  tab,
  order_by,
  order_dir,
  distance_km,
  event_age_group,
  enabled = true, // Changed default to true for better UX
  q,
  filter_my_event_type,
  filter_type,
  user_id,
  timeframe,
  isNeighbourhood = false,
}: Omit<GetEventsParams, 'offset' | 'limit'> & {enabled?: boolean}) => {
  return useOptimizedEvents({
    tab,
    order_by,
    order_dir,
    distance_km,
    event_age_group,
    enabled,
    q,
    filter_my_event_type,
    filter_type,
    user_id,
    timeframe,
    isNeighbourhood,
    // Enable performance optimizations
    prefetchNext: true,
    backgroundRefetch: true,
  });
};
*/
